/* Hodnocení receptu hvězdičkami (econea.cz). Zadal Zdeněk Dvořák (Linki), 2026-10.
   Hlas jde na Mechanic webhook. Značka v localStorage brání druhému hlasu z téhož prohlížeče,
   druhou pojistku (otisk IP) drží úloha v Mechanicu. */

/* Kotvy #krok-N pro kroky postupu. Na ně míří url kroků v Recipe JSON-LD
   (snippets/econea-recipe-jsonld.liquid); kroky kreslí recipe-detail.liquid z webpacku. */
(function () {
  var steps = document.querySelectorAll('.recipe-detail__method-step');
  for (var i = 0; i < steps.length; i++) {
    if (!steps[i].id) steps[i].id = 'krok-' + (i + 1);
  }
  if (/^#krok-\d+$/.test(location.hash)) {
    var target = document.getElementById(location.hash.slice(1));
    if (target) target.scrollIntoView();
  }
})();

/* Tlačítko a odkaz na suroviny z receptu (2026-10-22): událost recipe_ingredients_jump,
   jump_position = top (pod nadpisem) | ingredients (pod ingrediencemi).
   gtag vzniká až po první interakci (Avada / yett), proto událost chvíli počká,
   stejně jako v snippets/econea-header-tracking.liquid. */
(function () {
  if (window.erJumpReady) return;
  window.erJumpReady = true;
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('[data-er-jump]');
    if (!el) return;
    var params = {
      jump_position: el.getAttribute('data-er-jump'),
      recipe_handle: el.getAttribute('data-handle') || '',
      send_to: 'G-JSQ5TT7D3M'
    };
    var tries = 0;
    (function send() {
      if (typeof window.gtag === 'function') {
        try { window.gtag('event', 'recipe_ingredients_jump', params); } catch (err) {}
      } else if (tries++ < 50) {
        setTimeout(send, 100);
      }
    })();
  }, true);
})();

(function () {
  var box = document.querySelector('[data-er-vote]');
  if (!box || box.getAttribute('data-er-ready')) return;
  box.setAttribute('data-er-ready', '1');

  var handle = box.getAttribute('data-handle');
  var endpoint = box.getAttribute('data-endpoint');
  var stars = box.querySelectorAll('.er-vote__star');
  var status = box.querySelector('[data-er-status]');
  var honeypot = box.querySelector('.er-hp input');
  var storageKey = 'econea-recept-hodnoceni:' + handle;

  function readVote() {
    try { return parseInt(window.localStorage.getItem(storageKey), 10) || 0; } catch (e) { return 0; }
  }
  function saveVote(value) {
    try { window.localStorage.setItem(storageKey, String(value)); } catch (e) {}
  }
  function paint(value, cls) {
    for (var i = 0; i < stars.length; i++) {
      stars[i].classList.toggle(cls, i < value);
    }
  }
  function lock(value) {
    paint(value, 'is-on');
    for (var i = 0; i < stars.length; i++) {
      stars[i].disabled = true;
      stars[i].setAttribute('aria-pressed', i === value - 1 ? 'true' : 'false');
    }
    box.classList.add('is-done');
  }
  function unlock() {
    for (var i = 0; i < stars.length; i++) stars[i].disabled = false;
    box.classList.remove('is-sending');
  }
  function track(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  }

  var previous = readVote();
  if (previous) {
    lock(previous);
    status.textContent = box.getAttribute('data-msg-voted');
  }

  function preview(value) { if (!box.classList.contains('is-done')) paint(value, 'is-hover'); }
  for (var i = 0; i < stars.length; i++) {
    (function (star, value) {
      star.addEventListener('mouseenter', function () { preview(value); });
      star.addEventListener('focus', function () { preview(value); });
      star.addEventListener('blur', function () { preview(0); });
      star.addEventListener('click', function () { send(value); });
    })(stars[i], i + 1);
  }
  box.querySelector('.er-vote__stars').addEventListener('mouseleave', function () { preview(0); });

  function send(value) {
    if (box.classList.contains('is-done') || box.classList.contains('is-sending')) return;
    box.classList.add('is-sending');
    paint(0, 'is-hover');
    paint(value, 'is-on');
    for (var i = 0; i < stars.length; i++) stars[i].disabled = true;
    status.textContent = box.getAttribute('data-msg-sending');

    fetch(endpoint, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ recept: handle, hvezdy: value, web: honeypot ? honeypot.value : '' })
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      saveVote(value);
      lock(value);
      box.classList.remove('is-sending');
      status.textContent = box.getAttribute('data-msg-thanks');
      track('recipe_rating_submit', { recipe_handle: handle, rating: value });
    }).catch(function () {
      paint(0, 'is-on');
      unlock();
      status.textContent = box.getAttribute('data-msg-error');
      track('recipe_rating_error', { recipe_handle: handle });
    });
  }

  if ('IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        track('recipe_rating_view', { recipe_handle: handle, already_rated: previous ? 'yes' : 'no' });
        seen.disconnect();
      }
    }, { threshold: 0.5 });
    seen.observe(box);
  }

  var summary = document.querySelector('[data-er-sum]');
  if (summary) {
    summary.addEventListener('click', function () { track('recipe_rating_summary_click', { recipe_handle: handle }); });
  }
})();
